import { observer } from 'mobx-react';
import { WoundOrderAddWoundDressingViewStore } from '../stores';
import { setCurrentView } from 'core/utils';
import React from 'react';
import { WoundOrderAddWoundDressingTemplate } from 'themes/application/wound-order/pages';

@setCurrentView((rootStore) => new WoundOrderAddWoundDressingViewStore(rootStore), 'woundOrderAddWoundDressingViewStore')
@observer
class WoundOrderAddWoundDressingPage extends React.Component {
    render(){
        return <WoundOrderAddWoundDressingTemplate {...this.props} />
    }
}

export default WoundOrderAddWoundDressingPage;